function noop() {}

export default noop;


//////////////////
// WEBPACK FOOTER
// ./node_modules/instantsearch.js/es/lib/utils/noop.js
// module id = null
// module chunks = 